export default "__VITE_PUBLIC_ASSET__1fc28453__"